"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'formio-tab-panel-active': 'active',
    'formio-tab-link-active': 'active',
    'formio-tab-link-container-active': 'active',
};
